function MemberService($q, $rootScope, BBModel) {
    'ngInject';

    return {
        refresh(member) {
            const deferred = $q.defer();
            member.$flush('self');
            member.$get('self').then((member) => {
                    member = new BBModel.Member.Member(member);
                    return deferred.resolve(member);
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        current() {
            const deferred = $q.defer();
            const callback = () => deferred.resolve($rootScope.member);
            setTimeout(callback, 200);
            // member = () ->
            // deferred.resolve($rootScope.member)
            return deferred.promise;
        },

        updateMember(member, params) {
            const deferred = $q.defer();
            member.$put('self', {}, params).then((member) => {
                    member = new BBModel.Member.Member(member);
                    return deferred.resolve(member);
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        sendWelcomeEmail(member, params) {
            const deferred = $q.defer();
            member.$post('send_welcome_email', params).then((member) => {
                    member = new BBModel.Member.Member(member);
                    return deferred.resolve(member);
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        }
    };
}

angular
    .module('BBMember')
    .service('MemberService', MemberService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_services/member.service.js